import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Login, Dashboard, MerchantRegistration, Profile } from "../pages";
import Orders from "../pages/Orders";
import OrderDetail from "../pages/Orders/OrderDetail";
import Reports from "../pages/Reports";
import Rating from "../pages/Rating";
import Wallet from "../pages/Wallet";
import { DiscountVouchers, CreateVoucher } from "../pages/DiscountVouchers";
import NotFoundPage from "../pages/NotFoundPage";

import DashboardLayout from "../layouts/DashboardLayout/DashboardLayout";
import { ROUTES } from "../constants";
import { isAuthenticated } from "../services/auth.service";
import ForgotPassword from "../pages/Login/forgotpassword/ForgotPassword";
import ProfileSignContract from "../pages/Profile/molecues/ProfileSignContract";
import FoodPage from "../pages/Menu/FoodPage";
import MenuManagement from "../pages/Menu/MenuManagement";
import BundleDeal from "../pages/Menu/BundleDeal";
import AddNewBundleDeal from "../pages/Menu/AddNewBundleDeal";
import ReviewFoodMenu from "../pages/Menu/ReviewFoodMenu";
import FoodEntry from "../pages/Menu/FoodEntry/AddNewFoodMenu";

// Protected route component
const ProtectedRoute: React.FC<{ element: React.ReactNode }> = ({
  element,
}) => {
  return isAuthenticated() ? (
    <>{element}</>
  ) : (
    <Navigate to={ROUTES.LOGIN} replace />
  );
};

// Public route component (redirects to dashboard if already authenticated)
const PublicRoute: React.FC<{ element: React.ReactNode }> = ({ element }) => {
  return !isAuthenticated() ? (
    <>{element}</>
  ) : (
    <Navigate to={ROUTES.DASHBOARD} replace />
  );
};

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route
        path={ROUTES.LOGIN}
        element={<PublicRoute element={<Login />} />}
      />

      <Route
        path="/forgot-password/*"
        element={<PublicRoute element={<ForgotPassword />} />}
      />

      {/* Merchant Registration Routes - Fixed Structure */}
      <Route path="/merchant-registration">
        <Route
          index
          element={<Navigate to="/merchant-registration/step-1" replace />}
        />

        <Route
          path="/merchant-registration/:stepId"
          element={<MerchantRegistration />}
        />
      </Route>

      <Route
        path={ROUTES.MERCHANT_REGISTRATION_KYB}
        element={<PublicRoute element={<MerchantRegistration />} />}
      />

      <Route
        path={ROUTES.SIGNAGREE}
        element={<ProtectedRoute element={<ProfileSignContract />} />}
      />

      <Route
        path={ROUTES.DASHBOARD_KYB}
        element={<PublicRoute element={<Dashboard />} />}
      />

      <Route element={<ProtectedRoute element={<DashboardLayout />} />}>
        <Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
        <Route path={ROUTES.FOOD_PAGE} element={<FoodPage />} />
        <Route path={ROUTES.ADD_NEW_FOOD_MENU} element={<FoodEntry />} />

        <Route path={ROUTES.MENU_MANAGEMENT} element={<MenuManagement />} />
        <Route path={ROUTES.BUNDLE_DEAL} element={<BundleDeal />} />
        <Route
          path={ROUTES.ADD_NEW_BUNDLE_DEAL}
          element={<AddNewBundleDeal />}
        />
        <Route path={ROUTES.REVIEW_FOOD_MENU} element={<ReviewFoodMenu />} />

        <Route path={ROUTES.ORDERS} element={<Orders />} />
        <Route path={ROUTES.ORDER_DETAILS} element={<OrderDetail />} />
        <Route path={ROUTES.REPORTS} element={<Reports />} />
        <Route path={ROUTES.RATINGS} element={<Rating />} />
        <Route path={ROUTES.WALLET} element={<Wallet />} />

        <Route path={ROUTES.PROFILE} element={<Profile />} />
        <Route path={ROUTES.REVIEWS} element={<Rating />} />
        <Route path={ROUTES.DISCOUNT_VOUCHERS} element={<DiscountVouchers />} />
        <Route path={ROUTES.ADD_VOUCHER} element={<CreateVoucher />} />
        <Route path={ROUTES.EDIT_VOUCHER} element={<CreateVoucher />} />
      </Route>

      <Route
        path={ROUTES.HOME}
        element={
          isAuthenticated() ? (
            <Navigate to={ROUTES.DASHBOARD} replace />
          ) : (
            <Navigate to={ROUTES.LOGIN} replace />
          )
        }
      />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
